import { ColumnDef, CellContext, SortingFn } from "@tanstack/react-table";

const numericSorting: SortingFn<any> = (rowA, rowB, columnId) => {
  const valueA = Number(rowA.getValue(columnId));
  const valueB = Number(rowB.getValue(columnId));
  const valueAIsNaN = Number.isNaN(valueA);
  const valueBIsNaN = Number.isNaN(valueB);

  if (valueAIsNaN) {
    return valueBIsNaN ? 0 : 1;
  }

  if (valueBIsNaN) {
    return -1;
  }

  return valueA - valueB;
};

const DisplayNumberCell = (data: CellContext<any, unknown>) => {
  const value = data.getValue<number>() || 0;
  return (
    <div className="text-right">
      {Number(Number(value).toFixed(2)).toLocaleString("en-US")}
    </div>
  );
};

export const COLUMNS: ColumnDef<any>[] = [
  {
    accessorKey: "no",
    header: "No",
    enableSorting: false,
    cell: (data) => {
      const value = data.getValue<number>();
      return <div className="text-center">{value}</div>;
    },
  },
  {
    accessorKey: "name",
    header: "Name",
    enableSorting: false,
    cell: (data) => {
      const value = data.getValue<string>();
      const isMember = data.row.original.position === "MEMBER";

      return (
        <div
          className="text-center cursor-pointer font-bold"
          onClick={() => {
            if (isMember) {
              (data as any)?.onClickMember(value);
              return;
            }
            (data as any)?.onChangeFocusUser(value);
          }}
        >
          {isMember ? `${value}`.replace((data as any).focusUser, "") : value}
        </div>
      );
    },
  },
  {
    accessorKey: "tickets",
    header: "Ticket",
    sortingFn: numericSorting,
    cell: DisplayNumberCell,
  },
  {
    accessorKey: "betAmount",
    header: "Bet amount",
    sortingFn: numericSorting,
    cell: DisplayNumberCell,
  },
  {
    accessorKey: "winLose",
    header: "Win lose 100%",
    sortingFn: numericSorting,
    cell: DisplayNumberCell,
  },
];
